const onDocumentReady = (callback) => {
    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            callback,
            { once: true }
        );
    } else {
        callback();
    }
};

(() => {
    let fullHeaderHeight = 0;

    const setHeroPadding = () => {
        const announcementBar = document.querySelector('.announcement-bar');

        const headerTop = document.querySelector(
            '.header__row.header__row--top'
        );

        const isAnnouncementHidden =
            !announcementBar ||
            window.getComputedStyle(announcementBar).display === 'none';

        const announcementHeight = isAnnouncementHidden
            ? 0
            : announcementBar.offsetHeight;

        // The header slims down once scrolled (body.header-active). Measuring it in that state
        // gives too little padding, so the full-height header covers the page top when scrolling
        // back up. Keep the last full-height measurement and only re-measure when expanded.
        const isSlim = document.body.classList.contains('header-active');
        if (!isSlim && headerTop) {
            fullHeaderHeight = headerTop.offsetHeight;
        }
        const headerHeight = isSlim && fullHeaderHeight
            ? fullHeaderHeight
            : headerTop?.offsetHeight || 0;

        const totalHeight = announcementHeight + headerHeight;

        // After MainContent, if the next sibling is a <section>, pad it too
        const mainContent = document.getElementById('MainContent');

        if (mainContent) {
            // mainContent.style.paddingTop = `${totalHeight}px`;
            mainContent.style.paddingTop = `${totalHeight - 1}px`;

            // Add a gap filler to perfectly blend the header and hero section during height animations
            let filler = document.getElementById('header-gap-filler');
            if (!filler) {
                filler = document.createElement('div');
                filler.id = 'header-gap-filler';
                filler.style.position = 'absolute';
                filler.style.top = '0';
                filler.style.left = '0';
                filler.style.width = '100%';
                filler.style.zIndex = '-1';

                let bgColor = '#d5eaff';
                const headerRow = document.querySelector('header .header__row');
                if (headerRow) {
                    const computedBg = window.getComputedStyle(headerRow).backgroundColor;
                    if (computedBg && computedBg !== 'rgba(0, 0, 0, 0)' && computedBg !== 'transparent') {
                        bgColor = computedBg;
                    }
                }
                filler.style.backgroundColor = bgColor;
                document.body.insertBefore(filler, document.body.firstChild);
            }
            filler.style.height = `${totalHeight - 1}px`;

            // const firstEl = mainContent.firstElementChild;

            // if (firstEl && firstEl.tagName.toLowerCase() === 'section') {
            //   firstEl.style.paddingTop = `${totalHeight}px`;
            // }
        }
    };

    const initHeroPadding = () => {
        const announcementBar = document.querySelector('.announcement-bar');

        const hiddenUntil = localStorage.getItem(
            'announcementBarHiddenUntil'
        );

        if (announcementBar) {
            if (
                hiddenUntil &&
                Date.now() < parseInt(hiddenUntil)
            ) {
                announcementBar.classList.add('disable');
            } else {
                announcementBar.classList.remove('disable');
                localStorage.removeItem(
                    'announcementBarHiddenUntil'
                );
            }
        }
        // wait for Shopify render
        setHeroPadding();
    };



    // UPDATED: Use the reusable DOM-ready helper.
    onDocumentReady(initHeroPadding);

    // Run again after full load
    window.addEventListener(
        'load',
        initHeroPadding
    );

    // Close announcement bar
    document.addEventListener('click', (e) => {
        if (
            e.target.closest(
                '.announcement-bar .top-bar-cross'
            )
        ) {
            const announcementBar =
                document.querySelector('.announcement-bar');

            if (announcementBar) {
                announcementBar.classList.add('disable');

                // Store for 1 day
                localStorage.setItem(
                    'announcementBarHiddenUntil',
                    Date.now() + 24 * 60 * 60 * 1000
                );
            }

            setHeroPadding();
        }
    });

    // Recalculate on resize
    window.addEventListener(
        'resize',
        setHeroPadding
    );

    // Re-measure once the header has expanded back to full height (after its .3s transition)
    let expandTimer;
    window.addEventListener('header-expanded', () => {
        clearTimeout(expandTimer);
        expandTimer = setTimeout(setHeroPadding, 350);
    });

    // Shopify editor
    document.addEventListener(
        'shopify:section:load',
        initHeroPadding
    );

    document.addEventListener(
        'shopify:section:reorder',
        initHeroPadding
    );
})();

const initHeaderScroll = () => {
    // Header Scroll up sticky behaviour, and remove sticky on scroll down
    // let lastScrollTop = 0;

    // const getAnnouncementHeight = () => {
    //     const announcementBar = document.querySelector('.announcement-bar');
    //     if (!announcementBar || window.getComputedStyle(announcementBar).display === 'none') {
    //         return 0;
    //     }
    //     return announcementBar.offsetHeight;
    // };

    // window.addEventListener('scroll', () => {
    //     const header = document.querySelector(
    //         '.header-section-block'
    //     );

    //     if (!header) return;

    //     if (
    //         document.documentElement?.classList.contains('theme-video-modal-open') ||
    //         document.documentElement?.classList.contains('fruit-modal-open') ||
    //         document.querySelector('.fruits-modal.is-open')
    //     ) {
    //         return;
    //     }

    //     const currentScroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    //     const maxScroll = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);

    //     // Clamp scroll position to avoid Safari rubber-banding elastic scroll bounce triggers
    //     const scrollTop = Math.min(Math.max(currentScroll, 0), maxScroll);

    //     const headerHeight = header.offsetHeight;
    //     const annHeight = getAnnouncementHeight();

    //     // Dynamically adjust top position to account for the announcement bar scrolling up
    //     // const baseTop = Math.max(0, annHeight - scrollTop);
    //     const baseTop = Math.max(-annHeight, -scrollTop);

    //     const scrollDifference = Math.abs(scrollTop - lastScrollTop);
    //     if (scrollDifference < 5 && scrollTop > 0 && scrollTop < maxScroll) {
    //         return;
    //     }

    //     // Only hide the header after we have scrolled past a safe threshold (to prevent top gap)
    //     const safeHideThreshold = Math.max(headerHeight * 1.5, 250);

    //     if (scrollTop <= annHeight) {
    //         // Disable transition when dynamically adjusting to scroll to avoid lag/rubber-banding
    //         header.style.transition = 'none';
    //     } else {
    //         // Restore CSS transition for smooth hide/show
    //         header.style.transition = '';
    //     }

    //     if (scrollTop > safeHideThreshold) {
    //         if (scrollTop > lastScrollTop) {
    //             header.style.top = `-${headerHeight}px`;
    //         } else {
    //             header.style.top = `${baseTop}px`;
    //         }
    //     } else {
    //         header.style.top = `${baseTop}px`;
    //     }

    //     lastScrollTop = scrollTop;
    // });

    // On scroll add header-active class in body
    // window.addEventListener('scroll', () => {
    //     const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    //     if (document.body) {
    //         // Delay making the header slim until we've scrolled down a bit to prevent a visual gap
    //         document.body.classList.toggle('header-active', scrollY > 120);
    //     }
    // });

    // optimised code 

    let lastScrollTop = 0;
    let isTicking = false;

    // Looked up once. These are live collections, so they stay current if the
    // theme editor re-renders a section; [0] is the same element querySelector() returns.
    const headerBlocks = document.getElementsByClassName('header-section-block');
    const announcementBars = document.getElementsByClassName('announcement-bar');
    const fruitsModals = document.getElementsByClassName('fruits-modal');

    const isFruitsModalOpen = () => {
        for (let i = 0; i < fruitsModals.length; i++) {
            if (fruitsModals[i].classList.contains('is-open')) return true;
        }
        return false;
    };

    const getAnnouncementHeight = () => {
        const announcementBar = announcementBars[0];
        if (!announcementBar || window.getComputedStyle(announcementBar).display === 'none') {
            return 0;
        }
        return announcementBar.offsetHeight;
    };

    const updateHeaderPosition = () => {
        const header = headerBlocks[0];

        if (!header) return;

        if (
            document.documentElement?.classList.contains('theme-video-modal-open') ||
            document.documentElement?.classList.contains('fruit-modal-open') ||
            isFruitsModalOpen()
        ) {
            return;
        }

        const currentScroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const maxScroll = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);

        // Clamp scroll position to avoid Safari rubber-banding elastic scroll bounce triggers
        const scrollTop = Math.min(Math.max(currentScroll, 0), maxScroll);

        const headerHeight = header.offsetHeight;
        const annHeight = getAnnouncementHeight();

        // Dynamically adjust top position to account for the announcement bar scrolling up
        // const baseTop = Math.max(0, annHeight - scrollTop);
        const baseTop = Math.max(-annHeight, -scrollTop);

        const scrollDifference = Math.abs(scrollTop - lastScrollTop);
        if (scrollDifference < 5 && scrollTop > 0 && scrollTop < maxScroll) {
            return;
        }

        // Only hide the header after we have scrolled past a safe threshold (to prevent top gap)
        const safeHideThreshold = Math.max(headerHeight * 1.5, 250);

        if (scrollTop <= annHeight) {
            // Disable transition when dynamically adjusting to scroll to avoid lag/rubber-banding
            header.style.transition = 'none';
        } else {
            // Restore CSS transition for smooth hide/show
            header.style.transition = '';
        }

        if (scrollTop > safeHideThreshold) {
            if (scrollTop > lastScrollTop) {
                header.style.top = `-${headerHeight}px`;
            } else {
                header.style.top = `${baseTop}px`;
            }
        } else {
            header.style.top = `${baseTop}px`;
        }

        lastScrollTop = scrollTop;
    };

    // On scroll add header-active class in body
    const updateHeaderActiveClass = () => {
        const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (document.body) {
            // Delay making the header slim until we've scrolled down a bit to prevent a visual gap
            const wasActive = document.body.classList.contains('header-active');
            const isActive = scrollY > 120;
            document.body.classList.toggle('header-active', isActive);
            if (wasActive && !isActive) window.dispatchEvent(new Event('header-expanded'));
        }
    };

    // Single scroll listener, throttled to at most one update per animation frame.
    // Runs in the same order as the two original listeners.
    window.addEventListener('scroll', () => {
        if (isTicking) return;
        isTicking = true;

        window.requestAnimationFrame(() => {
            updateHeaderPosition();
            updateHeaderActiveClass();
            isTicking = false;
        });
    }, { passive: true });
};

onDocumentReady(initHeaderScroll);

document.querySelectorAll('.banner__marquee-block').forEach((marquee) => {
    const currentSection = marquee.closest('section');

    if (!currentSection) return;

    const prevInner = currentSection.previousElementSibling?.querySelector('section, div');
    const nextInner = currentSection.nextElementSibling?.querySelector('section, div');

    if (prevInner) prevInner.style.paddingBottom = '63px';
    if (nextInner) nextInner.style.paddingTop = '63px';
});

// Remove default on load open dropdown for submenu drawer
// const initMenuDrawer = () => {
//     document.querySelectorAll('.menu-drawer__menu.has-submenu #Details-menu-drawer-products').forEach((el) => {
//         el.removeAttribute('open');
//     });
// };

const initMenuDrawer = () => {
    document.querySelectorAll('.menu-drawer__menu.has-submenu details[open]').forEach((el) => {
        el.removeAttribute('open');
    });
};

// UPDATED: Use the reusable DOM-ready helper.
onDocumentReady(initMenuDrawer);

// Add class in body from data-template
document.addEventListener('DOMContentLoaded', function () {
    const mainContent = document.getElementById('MainContent');


});